














import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import DCascader from '../../d-cascader';
import {Area} from './area';
import {China} from './static/data';

Vue.use(DCascader);
@Component({
  name: 'DArea',
  components: {}
})
export default class DArea extends Vue {
  @Prop({
    type: String
  })
  public size: 'small' | 'large' | 'default';
  @Prop({
    type: Array
  }) // 指定选中项：string[] | number[]
  public value: string[]; // 输入框大小：string，可选 large default small
  public data: Area[] = China; // 数据
  public names: string[] = [];
  public static install: any;

  // 匹配名称
  /**
   * 选择
   */
  public handleChanged(val: string[]): void {
    console.table(val);
    this.$emit('change', val);
  }
}
